import {
  CartGqlMock,
  DeliveryTimeGqlMock,
  GetEligibleFinancingGqlMock,
  KitGqlMock,
  KitsGqlMock,
  ScoreGqlMock,
  UserGqlMock,
} from './bff';
export default {
  user: UserGqlMock,
  score: ScoreGqlMock,
  kits: KitsGqlMock,
  kit: KitGqlMock,
  cart: CartGqlMock,
  deliveryTime: DeliveryTimeGqlMock,
  financing: GetEligibleFinancingGqlMock,
};
